import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../navigation/route/Route";
import Sms from "../../../../model/sms/Sms";
import "../notification/items/notificationItem.scss";

interface IComponentProps {
	/**
	 * Sms to display.
	 */
	sms: Sms;
	/**
	 * On item link click.
	 */
	onItemLinkClick: () => void;
}
type Props = IComponentProps & RouteComponentProps<IComponentProps> ;

class IncomingSmsItem extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
		this.renderCTA = this.renderCTA.bind(this);
	}

	render() {
		return (
			<div className={"c-notification"}>
				<div className={"notification-icon"}>
					<img src="/assets/img/icons/icn-act-note.svg"/>
				</div>
				<div className={"notification-body"}>
					<div className={"notification-header"}>
						SMS from {this.props.sms.individualContact.map(c => c.getName()).getOrElse(this.props.sms.phoneNumber)}
					</div>
					<div className={"notification-content"}>
						<span className="d-block">{this.props.sms.displayDate()}</span>
						<span>{this.props.sms.content}</span>
					</div>
					{this.props.sms.leadReferenceNumber.map(this.renderCTA).orNull}
				</div>
			</div>
		);
	}

	/**
	 * Render call to action buttons.
	 */
	renderCTA(refNumber: string) {
		return (
			<span className="notification-link" onClick={() => this.routeToLead(refNumber)}>View Lead</span>
		)
	}

	/**
	 * Route to proper lead.
	 * @param leadReferenceNumber lead identifier.
	 */
	routeToLead(leadReferenceNumber: string) {
		this.props.history.push(Routes.EditLead(leadReferenceNumber));
		this.props.onItemLinkClick();
	}
}

export default withRouter<IComponentProps>(IncomingSmsItem);